import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42b0eafb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid px-0 px-md-4 px-lg-5 mx-2 mx-md-4 mx-lg-5" }
const _hoisted_2 = { class: "banner-content" }

import { onMounted, onUnmounted, Ref, ref } from "vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'GenericBanner',
  props: {
    image: {}
  },
  setup(__props: any) {

  const props = __props;

  var banner: Ref<any> = ref();
  var bannerScrollOffset: Ref<any> = ref();
  function bannerScrollUpdate () {
    bannerScrollOffset.value = calcScrollOffset() + "px";
  }
  
  function calcScrollOffset () {
    const extraOffset = 40;
    return window.scrollY - (banner.value.offsetTop + extraOffset);
  }

  onMounted(async () => {
    bannerScrollOffset.value = calcScrollOffset() + "px";
    window.addEventListener('scroll', bannerScrollUpdate);
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', bannerScrollUpdate);
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "banner",
    ref: banner,
    class: "generic-banner text-white",
    style: _normalizeStyle({ '--top-scroll': _unref(bannerScrollOffset), '--header-bg': `url(${require('@/assets/' + _ctx.image.replace(/^\//g, ''))})` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ])
  ], 4))
}
}

})